<mat-sidenav-container class="sidenav-container">
  @if (isAuthenticated) {
    <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
      <div class="nav-container">
        <mat-toolbar class="logo">
          <a routerLink="">
            <img src="assets/logo.png" alt="bids_logo">
          </a>
        </mat-toolbar>
        <div class="pt-5">
          <ul class="menu">
            <li>
              <a routerLink="campaigns">
                <span routerLinkActive="active-link">Destaques</span>
              </a>
            </li>
            <li>
              <a routerLink="/portfolio">
                <span routerLinkActive="active-link">Portfolio</span>
              </a>
            </li>
            <li>
              <a routerLink="/orders">
                <span routerLinkActive="active-link">Encomendas</span>
              </a>
            </li>
            <li>
              <a routerLink="/campanhas">
                <span routerLinkActive="active-link">Campanhas</span>
              </a>
            </li>
            <li>
              <a routerLink="/pim">
                <span routerLinkActive="active-link">PIM</span>
              </a>
            </li>
            <li>
              <a routerLink="/external/pitch">
                <span routerLinkActive="active-link">20th Minutes Pitch</span>
              </a>
            </li>
            <li>
              <p class="upper">Montras Digitais</p>
              <ul class="menu">
                <li>
                  <a class="inner" routerLink="/external/management">
                    <span routerLinkActive="active-link">Gestão de Conteúdos</span>
                  </a>
                </li>
                <li>
                  <a class="inner" routerLink="/external/calendar">
                    <span routerLinkActive="active-link">Calendário</span>
                  </a>
                </li>
              </ul>
            </li>
            @if (isOperationalUser) {
              <li>
                <a routerLink="/operational">
                  <span routerLinkActive="active-link">Portal Operacional</span>
                </a>
              </li>
            }
            <li>
              <a mat-list-item routerLink="/account/login" (click)="loggedOut.emit()">Logout</a>
            </li>
          </ul>
        </div>
        <div class="help-container">
          <a class="help" routerLink="/external/help">
            <mat-icon fontSet="material-icons">support</mat-icon>
            <!-- <span> | </span> -->
            <p class="help-text">Precisa de ajuda?</p>
            <mat-icon fontSet="material-icons">chevron_right</mat-icon>
          </a>
        </div>
      </div>
    </mat-sidenav>
  }
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
